export const frontendPort = 3000;
export const frontendUrl = `http://localhost:${frontendPort}`;
export const backendPort = 3001;
// In production the SPA is served from the same origin as the API, so relative
// paths (`/api`, `/uploads/...`) are used. Webpack bakes NODE_ENV into the bundle
// (prod build => ''), dev keeps the absolute http://localhost:3001. The Node
// backend never uses this value (it only imports backendPort/frontendUrl).
export const backendUrl = process.env.NODE_ENV === 'production'
    ? ''
    : `http://localhost:${backendPort}`;
// Plain enums (not `const enum`): this file is compiled by two independent
// tsconfigs, and `const enum` breaks under isolatedModules/transpileOnly.
export var AvatarMode;
(function (AvatarMode) {
    AvatarMode[AvatarMode["Minimum"] = 0] = "Minimum";
    AvatarMode[AvatarMode["Exclusive"] = 1] = "Exclusive";
})(AvatarMode || (AvatarMode = {}));
export var AvatarRarity;
(function (AvatarRarity) {
    AvatarRarity[AvatarRarity["Common"] = 0] = "Common";
    AvatarRarity[AvatarRarity["Rare"] = 1] = "Rare";
    AvatarRarity[AvatarRarity["Epic"] = 2] = "Epic";
    AvatarRarity[AvatarRarity["Legendary"] = 3] = "Legendary";
    AvatarRarity[AvatarRarity["Mythic"] = 4] = "Mythic";
})(AvatarRarity || (AvatarRarity = {}));
export var LockStatus;
(function (LockStatus) {
    LockStatus["Locked"] = "Locked";
    LockStatus["Unlocked"] = "Unlocked";
})(LockStatus || (LockStatus = {}));
export var RetryStatus;
(function (RetryStatus) {
    RetryStatus["Yes"] = "Yes";
    RetryStatus["No"] = "No";
})(RetryStatus || (RetryStatus = {}));
// The narrative reason a failed trial can or cannot be retried — the missing link
// between the story fiction and retryability. The mapping to retry is deterministic
// (RETRY_POLICY), so "the bridge collapsed forever" can never be marked retryable.
// `allowRetry` on a SimpleEvent stays the ground truth (Modules 2/3 read it); when a
// fiction is authored it is derived from RETRY_POLICY and the verifier checks they agree.
export var FailureFiction;
(function (FailureFiction) {
    FailureFiction["Reversible"] = "Reversible";
    FailureFiction["Consumable"] = "Consumable";
    FailureFiction["Permanent"] = "Permanent";
    FailureFiction["Lethal"] = "Lethal";
    FailureFiction["Locking"] = "Locking";
})(FailureFiction || (FailureFiction = {}));
export const RETRY_POLICY = {
    [FailureFiction.Reversible]: true,
    [FailureFiction.Consumable]: true,
    [FailureFiction.Permanent]: false,
    [FailureFiction.Lethal]: false,
    [FailureFiction.Locking]: false,
};
/** Whether a trial with this failure fiction may be retried. */
export function retryFromFiction(fiction) {
    return RETRY_POLICY[fiction];
}
// --- Roles & moderation pipeline ---
// Who is acting. Creators build levels and their in-level content; admins manage
// the global libraries (NPCs/Resources/Market/Node Types/Statuses) and moderate
// submitted levels.
export var UserRole;
(function (UserRole) {
    UserRole["Creator"] = "Creator";
    UserRole["Admin"] = "Admin";
})(UserRole || (UserRole = {}));
// --- Admins & granular admin permissions ---
// An "admin" is a user whose Telegram username is present in the `admins`
// collection. The set of things an admin may DO is controlled by these granular
// permissions (an admin with none can still open the admin panel and VIEW the
// libraries read-only, but cannot mutate anything). The root admin bypasses every
// check and is undeletable. Enforced server-side on every mutating admin route.
export var AdminPermission;
(function (AdminPermission) {
    /** Create / edit / archive the shared reference libraries (node types, node
     *  statuses, resources, market items, scripts, shields, agents, NPCs, prompts,
     *  translations, settings, sounds, portal import). Without it → read-only. */
    AdminPermission["ManageEntities"] = "manage_entities";
    /** Create / edit / open-close / archive challenges. */
    AdminPermission["ManageChallenges"] = "manage_challenges";
    /** Approve / reject submitted levels (the moderation queue). */
    AdminPermission["ModerateLevels"] = "moderate_levels";
    /** Add / remove admins and set their permissions (sees the Admins panel). */
    AdminPermission["ManageAdmins"] = "manage_admins";
})(AdminPermission || (AdminPermission = {}));
export const ALL_ADMIN_PERMISSIONS = [
    AdminPermission.ManageEntities,
    AdminPermission.ManageChallenges,
    AdminPermission.ModerateLevels,
    AdminPermission.ManageAdmins,
];
// The single, undeletable super-admin. Seeded on boot with every permission and
// isRoot=true; cannot be demoted or removed by anyone (including itself).
export const ROOT_ADMIN_USERNAME = 'almiashev';
// Lifecycle of a level on its way to publication.
export var ModerationStatus;
(function (ModerationStatus) {
    ModerationStatus["Draft"] = "Draft";
    ModerationStatus["Pending"] = "Pending";
    ModerationStatus["Approved"] = "Approved";
    ModerationStatus["Rejected"] = "Rejected";
})(ModerationStatus || (ModerationStatus = {}));
// --- Two-stage review + the publication pipeline -------------------------------
//
// Stage 1 (story): Draft → Pending → Approved — the existing moderationStatus.
// Stage 2 (images), only meaningful once the story is Approved:
//   InProgress → (author finishes every image, presses "Submit images") →
//   Submitted → (moderator accepts) → Approved   |  (requests changes) → InProgress
// While Submitted/Approved, image edits are locked for EVERYONE (author and
// moderator alike) — the reviewed set must not drift under the reviewer.
export var ImagesStatus;
(function (ImagesStatus) {
    ImagesStatus["InProgress"] = "InProgress";
    ImagesStatus["Submitted"] = "Submitted";
    ImagesStatus["Approved"] = "Approved";
})(ImagesStatus || (ImagesStatus = {}));
export const IMAGES_STATUS_LABELS = {
    [ImagesStatus.InProgress]: 'Images in progress',
    [ImagesStatus.Submitted]: 'Images under review',
    [ImagesStatus.Approved]: 'Images approved',
};
// The handshake with the GAME's backend (agreed contract): it polls our Mongo for
// levels whose publicationStatus says they are cleared, imports them, and flips
// the status forward. OUR editor only ever sets Draft ↔ ApprovedForPublication
// (the moderator's Publish button); Publishing/Published are written by the game
// exporter. publicationStatusChangedAt records the last transition, whoever made it.
export var PublicationStatus;
(function (PublicationStatus) {
    PublicationStatus["Draft"] = "Draft";
    PublicationStatus["ApprovedForPublication"] = "ApprovedForPublication";
    PublicationStatus["Publishing"] = "Publishing";
    PublicationStatus["Published"] = "Published";
})(PublicationStatus || (PublicationStatus = {}));
// Short, badge-sized labels. To the author both hand-off states read as one
// thing — "it is being published" — so ApprovedForPublication and Publishing
// share the label; the exact stage lives in tooltips/notes where it matters.
export const PUBLICATION_STATUS_LABELS = {
    [PublicationStatus.Draft]: 'Draft',
    [PublicationStatus.ApprovedForPublication]: 'Publishing',
    [PublicationStatus.Publishing]: 'Publishing',
    [PublicationStatus.Published]: 'Published',
};
export function levelEditLock(status) {
    switch (status) {
        case ModerationStatus.Pending: return 'locked';
        case ModerationStatus.Approved: return 'image-only';
        case ModerationStatus.Draft:
        case ModerationStatus.Rejected: return 'editable';
        default: return 'editable';
    }
}
// --- Localization / translations (admin publishing flow) ----------------------
//
// Approved levels are authored in English (the SOURCE_LANGUAGE). Before a level can
// be published the admin generates translations of every player-facing string into
// each TARGET_LANGUAGE, reviews them, and approves each language. Approval is
// per-language (one click approves a whole language's set).
export const SOURCE_LANGUAGE = 'en';
// The game renders per-level content via a CASE-SENSITIVE lookup on the player's
// stored language code, so these codes must match the game's whitelist exactly
// (en, ru, it, fr, es, tr, zh-hans, ja, ko). Note zh-hans is lowercase — a capital
// "zh-Hans" silently misses and falls back to English for Chinese players.
/** The languages a level is translated INTO (English is the source, shown separately). */
export const TARGET_LANGUAGES = [
    { code: 'zh-hans', label: 'Chinese (Simplified)' },
    { code: 'ja', label: 'Japanese' },
    { code: 'ko', label: 'Korean' },
    { code: 'tr', label: 'Turkish' },
    { code: 'ru', label: 'Russian' },
    { code: 'es', label: 'Spanish' },
    { code: 'it', label: 'Italian' },
    { code: 'fr', label: 'French' },
];
/** Every supported language, English first (for display columns). */
export const ALL_LANGUAGES = [
    { code: SOURCE_LANGUAGE, label: 'English (source)' },
    ...TARGET_LANGUAGES,
];
// Mock-auth identity headers (the frontend sends the selected role + the
// creator's Telegram username; real auth replaces this later).
export const USER_ROLE_HEADER = 'x-user-role';
export const USER_NAME_HEADER = 'x-user-name';
// --- Auth (login via Telegram code) ---
// The flow: the user enters a Telegram username -> the backend generates a
// 6-digit code, stores it in Mongo and delivers it via the Tapper.Admin API ->
// the user enters the code -> the backend verifies it and issues a session
// token. The frontend sends the token in this header; a valid session
// overrides the mock USER_NAME_HEADER on the backend.
export const SESSION_TOKEN_HEADER = 'x-session-token';
export const LOGIN_CODE_LENGTH = 6;
// --- Challenges ---
// An admin-created brief: "design a level with these constraints". Creators take
// a challenge, which spawns a Draft level pre-filled with the structured
// constraints; on submit those constraints are hard-validated. Approved entries
// are the winners (there can be several).
export var ChallengeStatus;
(function (ChallengeStatus) {
    ChallengeStatus["Open"] = "Open";
    ChallengeStatus["Closed"] = "Closed"; // no new entries
})(ChallengeStatus || (ChallengeStatus = {}));
// enum for avatar characteristics (mirror on frontend)
export var AvatarAbility;
(function (AvatarAbility) {
    AvatarAbility["Strength"] = "Strength";
    AvatarAbility["Agility"] = "Agility";
    AvatarAbility["Perception"] = "Perception";
    AvatarAbility["Intellect"] = "Intellect";
    AvatarAbility["Defence"] = "Defence";
})(AvatarAbility || (AvatarAbility = {}));
// enum for prize types (mirror on frontend)
export var PrizeType;
(function (PrizeType) {
    PrizeType["Money"] = "Money";
    PrizeType["Resource"] = "Resource";
    PrizeType["Knowledge"] = "Knowledge";
})(PrizeType || (PrizeType = {}));
export var ResourceType;
(function (ResourceType) {
    ResourceType["Resource"] = "Resource";
    ResourceType["Artefact"] = "Artefact";
})(ResourceType || (ResourceType = {}));
// --- Dialogue Contract Types ---
export var DialogueRewardLevel;
(function (DialogueRewardLevel) {
    DialogueRewardLevel["None"] = "None";
    DialogueRewardLevel["Low"] = "Low";
    DialogueRewardLevel["Medium"] = "Medium";
    DialogueRewardLevel["High"] = "High";
})(DialogueRewardLevel || (DialogueRewardLevel = {}));
export var DialogueBackgroundMode;
(function (DialogueBackgroundMode) {
    DialogueBackgroundMode["Nodes"] = "Nodes";
    DialogueBackgroundMode["Map"] = "Map";
    DialogueBackgroundMode["Custom"] = "Custom";
})(DialogueBackgroundMode || (DialogueBackgroundMode = {}));
// Types of scannable resource selection
export var ScannableResourceSelectionType;
(function (ScannableResourceSelectionType) {
    ScannableResourceSelectionType["All"] = "all";
    ScannableResourceSelectionType["Random"] = "random";
    ScannableResourceSelectionType["Custom"] = "custom";
})(ScannableResourceSelectionType || (ScannableResourceSelectionType = {}));
// --- Story verification (Module 2: the automated solvability/consistency checker) ---
export var VerificationSeverity;
(function (VerificationSeverity) {
    VerificationSeverity["Error"] = "error";
    VerificationSeverity["Warning"] = "warning";
    VerificationSeverity["Info"] = "info";
})(VerificationSeverity || (VerificationSeverity = {}));
/** Stable machine keys so the UI can localize/route each finding. */
export var VerificationCode;
(function (VerificationCode) {
    VerificationCode["NoStart"] = "NO_START";
    VerificationCode["MultiStart"] = "MULTI_START";
    VerificationCode["GoalUndefined"] = "GOAL_UNDEFINED";
    VerificationCode["MultiGoal"] = "MULTI_GOAL";
    VerificationCode["GoalUnreachable"] = "GOAL_UNREACHABLE";
    /** The goal is reachable, but not on the all-success path — a gate only opens
     *  on a failure outcome, so the player can only win by deliberately failing. */
    VerificationCode["GoalUnreachableOnSuccess"] = "GOAL_UNREACHABLE_ON_SUCCESS";
    VerificationCode["UnlockTargetMissing"] = "UNLOCK_TARGET_MISSING";
    VerificationCode["LockTargetMissing"] = "LOCK_TARGET_MISSING";
    VerificationCode["UnlockNeverFires"] = "UNLOCK_NEVER_FIRES";
    VerificationCode["PanelMissing"] = "PANEL_MISSING";
    VerificationCode["OrphanPanel"] = "ORPHAN_PANEL";
    VerificationCode["UnreachableNode"] = "UNREACHABLE_NODE";
    VerificationCode["UnreachablePanel"] = "UNREACHABLE_PANEL";
    VerificationCode["IntendedEffectNeverFires"] = "INTENDED_EFFECT_NEVER_FIRES";
    VerificationCode["SelfLockContradiction"] = "SELF_LOCK_CONTRADICTION";
    /** RETIRED: an outcome with no effects is normal (a failure often does nothing),
     *  so this is no longer emitted. Kept in the enum only so old data/tests don't break. */
    VerificationCode["EmptyOutcome"] = "EMPTY_OUTCOME";
    /** A cell has several obstacles (approaches by different abilities), but the same
     *  outcome opens the way on some and not others — a player who resolves the "wrong"
     *  way could get stuck. Every obstacle on a cell should unlock the same onward path. */
    VerificationCode["InconsistentOutcomeUnlocks"] = "INCONSISTENT_OUTCOME_UNLOCKS";
    VerificationCode["RetryFictionMismatch"] = "RETRY_FICTION_MISMATCH";
    /** A cell the game will never read (Empty type / no type / wall) still carries
     *  an obstacle — dead content, and often a hole blown in the intended route. */
    VerificationCode["ContentOnImpassableCell"] = "CONTENT_ON_IMPASSABLE_CELL";
    /** A cell attachment references an event that no longer exists actively
     *  (deleted/archived): play shows the stale denormalized texts, but the trial
     *  behind them is gone — the attempt silently does nothing. */
    VerificationCode["BrokenEventRef"] = "BROKEN_EVENT_REF";
    /** The START cell carries a trial. The game engine cannot run an event on
     *  the spawn cell — the start must be empty of events, always. */
    VerificationCode["TrialOnStart"] = "TRIAL_ON_START";
    VerificationCode["VerificationTruncated"] = "VERIFICATION_TRUNCATED";
})(VerificationCode || (VerificationCode = {}));
/** The findings computeRepairs can fix mechanically. Everything else (design
 *  problems like an unreachable goal) needs hand edits — the UI uses this to
 *  show the Fix button only when pressing it would actually do something. */
export const AUTO_FIXABLE_CODES = [
    VerificationCode.RetryFictionMismatch,
    VerificationCode.UnlockTargetMissing,
    VerificationCode.LockTargetMissing,
    VerificationCode.PanelMissing,
    VerificationCode.UnlockNeverFires,
];
// --- Image/Art Contract Types ---
export var ImageType;
(function (ImageType) {
    ImageType["MapNode"] = "MapNode";
    ImageType["DialogueBackground"] = "DialogueBackground";
    ImageType["EventCard"] = "EventCard";
})(ImageType || (ImageType = {}));
/** Human labels for each slot kind, for the studio header. */
export const ART_SLOT_LABELS = {
    trialCard: 'Obstacle card',
    trialBackground: 'Obstacle scene',
    modalCentre: 'UX panel art',
    modalBackground: 'UX panel backdrop',
    levelCover: 'Level cover',
};
/* ===========================================================================
 * MAP GEOMETRY — how the game actually lays a level out. Read this before
 * touching any map rendering; the editor must mirror it exactly.
 *
 * The game draws the background image at its NATURAL pixel size and drops the
 * cells on a fixed 92px pitch from the image's TOP-LEFT corner
 * (game: Adventure/Field/Field.styled.ts — `top: 92*y; left: 92*x`, the visible
 * 80px circle centred in that 92px box).
 *
 * The grid it walks is PADDED: the server emits (11 + 2*2) = 15 rows/columns and
 * leaves the outer 2 rings null — decorative surround the player never steps on
 * (game backend: Tapper.Models/Common/Portals/PortalMap.cs — Size_ = 11,
 * Padding = 2; AdventureService.CreateStateResponse skips IsOnPadding).
 *
 * Therefore:
 *   • the background must be 15 * 92 = 1380 x 1380 px;
 *   • the AUTHORED 11x11 grid sits inset by 2 cells = 184 px on every side;
 *   • the author's cell (x, y) covers image pixels
 *       left = (x + 2) * 92, top = (y + 2) * 92, 92 x 92.
 * An image of any other size makes the game place cells off the picture — the
 * "level does not start" report that produced these constants.
 * =========================================================================== */
/* ===========================================================================
 * ODDS CURVE — how the game turns "agent stat vs trial difficulty" into a
 * success chance (AdventureService.GetChallengeSuccessChanceFactor):
 *
 *     xMid = (xLow + d) / 2
 *     k    = 2*ln((1/pLow - 1)/(1/pHigh - 1)) / (d - xLow)
 *     p    = 0.9 / (1 + e^(-k*(x - xMid)))
 *
 * where d is the TRIAL's difficulty and x the agent's ability. The four numbers
 * below are per-LEVEL and anchor the curve on two points: an agent at `xLow`
 * passes with `pLow`, an agent at the trial's own difficulty passes with `pHigh`.
 *
 * They must differ. With pLow == pHigh the logarithm is ln(1) = 0, so k = 0 and
 * EVERY trial collapses to a flat 0.9/(1+e^0) = 45% no matter its difficulty —
 * and a level missing them entirely divides by zero, giving NaN (the game's
 * `p < 0.01` floor does not catch NaN). Both were live bugs.
 *
 * These are the values the shipped City-18 uses; every level gets them at
 * creation so the editor, the exporter and the game all read real numbers.
 * =========================================================================== */
export const DEFAULT_ODDS_CURVE = {
    /** Chance for an agent whose ability equals xLow (a weak agent). */
    pLow: 0.4,
    /** Chance for an agent whose ability equals the trial's difficulty. */
    pHigh: 0.8,
    /** Ability value of the "weak agent" anchor. */
    xLow: 40,
    /** Upper reference ability. Stored for round-trips; the live curve does not read it. */
    xHigh: 130,
};
/** Pixel pitch of one map cell in the game. */
export const MAP_CELL_PX = 92;
/** Authored (playable) grid side — the game's PortalMap.Size_. */
export const MAP_GRID_CELLS = 11;
/** Decorative rings the game adds around the authored grid, per side. */
export const MAP_PADDING_CELLS = 2;
/** Padded side in cells: what the game actually renders (11 + 2*2 = 15). */
export const MAP_PADDED_CELLS = MAP_GRID_CELLS + MAP_PADDING_CELLS * 2;
/** Canonical background size in pixels: 15 * 92 = 1380. */
export const MAP_IMAGE_PX = MAP_PADDED_CELLS * MAP_CELL_PX;
/** Upload kinds that ship art into the game, with every size that kind may carry.
 *  A kind with several entries feeds several game slots from ONE image pool, so any
 *  of its sizes is acceptable at upload time. Kinds absent from this map (dialogue,
 *  item, mission art) are not game-slot art and stay free. */
export const GAME_IMAGE_SIZES = {
    'node-images': [{ width: 1084, height: 1410, slot: 'trial card' }],
    'event-images': [{ width: 1179, height: 2214, slot: 'trial background' }],
    'ux-panel-images': [
        { width: 1080, height: 1920, slot: 'modal background' },
        { width: 960, height: 1248, slot: 'modal centre image' },
    ],
    // The level's cover (the game's Portal.iconUrl tile). 1024x1024 WebP by canon:
    // it is every image generator's native square (our AI pipeline emits it without
    // recompression), triple-retina headroom, and one source covers the game's
    // 1:1.12 tile (cover-crop ~±11% at the sides — keep the subject centred) plus
    // any future placement. Serve downsized via the /uploads?w= resizer.
    'level-cover': [{ width: 1024, height: 1024, slot: 'level cover' }],
};
/** Human-readable list of the sizes a kind allows, e.g. "1080×1920 (modal background)
 *  or 960×1248 (modal centre image)". */
export function describeAllowedSizes(kind) {
    const sizes = GAME_IMAGE_SIZES[kind];
    if (!(sizes === null || sizes === void 0 ? void 0 : sizes.length))
        return '';
    return sizes.map(s => `${s.width}×${s.height} (${s.slot})`).join(' or ');
}
/** Null when the size is allowed (or the kind is ungated); otherwise the message to
 *  show the author. Shared by the browser pre-check and the server-side gate so both
 *  say exactly the same thing. */
export function validateGameImageSize(kind, width, height) {
    const sizes = GAME_IMAGE_SIZES[kind];
    if (!(sizes === null || sizes === void 0 ? void 0 : sizes.length))
        return null;
    if (!width || !height)
        return `Could not read the image size. Expected ${describeAllowedSizes(kind)}.`;
    if (sizes.some(s => s.width === width && s.height === height))
        return null;
    return `Wrong image size: ${width}×${height}. This slot needs exactly ${describeAllowedSizes(kind)}.`;
}
// --- Market Item Contract Types ---
export var MarketItemCategory;
(function (MarketItemCategory) {
    MarketItemCategory["Avatars"] = "Avatars";
    MarketItemCategory["Boosters"] = "Boosters";
    MarketItemCategory["AutoClaim"] = "AutoClaim";
    MarketItemCategory["BarrackSlots"] = "Barack Slots";
    MarketItemCategory["Knowledge"] = "Knowledge";
    MarketItemCategory["Coins"] = "Coins";
    MarketItemCategory["CrashEggs"] = "Crash Eggs"; // displayed as Energy Cells
})(MarketItemCategory || (MarketItemCategory = {}));
// --- Trigger Contract Types ---
export var TriggerGroupType;
(function (TriggerGroupType) {
    TriggerGroupType["MapPoint"] = "MapPoint";
    TriggerGroupType["HealthStatus"] = "HealthStatus";
    TriggerGroupType["Time"] = "Time";
})(TriggerGroupType || (TriggerGroupType = {}));
// --- New types for trigger conditions ---
export var GamePhase;
(function (GamePhase) {
    GamePhase["Preparation"] = "Preparation";
    GamePhase["Exploration"] = "Exploration";
    GamePhase["Combat"] = "Combat";
    GamePhase["Rest"] = "Rest";
    GamePhase["EndGame"] = "EndGame";
})(GamePhase || (GamePhase = {}));
export var ScenarioStatus;
(function (ScenarioStatus) {
    ScenarioStatus["NotStarted"] = "NotStarted";
    ScenarioStatus["InProgress"] = "InProgress";
    ScenarioStatus["Completed"] = "Completed";
    ScenarioStatus["Failed"] = "Failed";
})(ScenarioStatus || (ScenarioStatus = {}));
/** The routable AI jobs. */
export var AiTask;
(function (AiTask) {
    /** Story bible + per-cell trials + the map art plan. */
    AiTask["Text"] = "text";
    /** Level string localization. */
    AiTask["Translation"] = "translation";
    /** Cheap first-pass map render (img2img over the segmentation blueprint). */
    AiTask["ImageDraft"] = "imageDraft";
    /** Final map render (img2img over the draft/blueprint). */
    AiTask["ImageFinal"] = "imageFinal";
    /** Reading an uploaded map image (vision) to ground the trials in what's on it. */
    AiTask["Vision"] = "vision";
})(AiTask || (AiTask = {}));
/** Providers that can actually serve each task. */
export const AI_TASK_PROVIDERS = {
    [AiTask.Text]: ['anthropic', 'openai', 'gemini'],
    [AiTask.Translation]: ['anthropic', 'openai', 'gemini'],
    [AiTask.ImageDraft]: ['fal', 'openai'],
    [AiTask.ImageFinal]: ['openai', 'fal'],
    // fal only GENERATES images — it can't read one, so vision is Claude/OpenAI/Gemini.
    [AiTask.Vision]: ['anthropic', 'openai', 'gemini'],
};
/** Mirrors the original hard-coded wiring, so an unconfigured install is unchanged. */
export const DEFAULT_AI_ROUTING = {
    [AiTask.Text]: 'anthropic',
    [AiTask.Translation]: 'anthropic',
    [AiTask.ImageDraft]: 'fal',
    [AiTask.ImageFinal]: 'openai',
    [AiTask.Vision]: 'anthropic',
};
export function aiProviderCanServe(task, provider) {
    return AI_TASK_PROVIDERS[task].includes(provider);
}
// Cost hints are per AVERAGE LEVEL, not per token — that's the unit the admin
// budgets in. Text baseline: one full story generation of an 11×11 level at 45%
// fill ≈ 15K input + 24K output tokens (vision + story + ~54 trials + modals +
// art plan). Image baseline: ≈110 images per level (2 per obstacle + 2 per
// notification), billed at 2MP each on fal.
export const AI_PROVIDER_MODELS = {
    anthropic: [
        { id: 'claude-sonnet-5', label: 'Sonnet 5', hint: 'balanced — ≈$0.27 per level' },
        { id: 'claude-opus-4-8', label: 'Opus 4.8', hint: 'top quality — ≈$0.67 per level' },
        { id: 'claude-haiku-4-5-20251001', label: 'Haiku 4.5', hint: 'cheapest — ≈$0.13 per level' },
    ],
    openai: [
        { id: 'gpt-5', label: 'GPT-5', hint: 'default' },
    ],
    gemini: [
        { id: 'gemini-3.5-flash', label: 'Gemini 3.5 Flash', hint: 'fast — ≈$0.24 per level' },
        { id: 'gemini-3.1-pro', label: 'Gemini 3.1 Pro', hint: 'quality — ≈$0.32 per level' },
        { id: 'gemini-3-flash', label: 'Gemini 3 Flash', hint: 'cheapest — ≈$0.08 per level' },
    ],
    fal: [
        { id: 'fal-ai/flux/dev', label: 'FLUX.1 dev', hint: 'quality — ≈$12 per level (110 images)' },
        { id: 'fal-ai/flux/schnell', label: 'FLUX.1 schnell', hint: 'cheap — ≈$0.66 per level (110 images)' },
    ],
};
/** What each provider runs when the admin has not picked anything. */
export const DEFAULT_PROVIDER_MODELS = {
    anthropic: 'claude-sonnet-5',
    openai: 'gpt-5',
    gemini: 'gemini-3.5-flash',
    fal: 'fal-ai/flux/dev',
};
export const DEFAULT_GENERATOR_MODE = 'route';
export function isGeneratorMode(v) {
    return v === 'route' || v === 'legacy';
}
// --- Level generation design inputs ---------------------------------------
/** Narrative tone the author writes in. Steers the AI text (setting/trials/modals). */
export var StoryTone;
(function (StoryTone) {
    StoryTone["Neutral"] = "neutral";
    StoryTone["Intriguing"] = "intriguing";
    StoryTone["Dark"] = "dark";
    StoryTone["Horror"] = "horror";
    StoryTone["Noir"] = "noir";
    StoryTone["BlackHumor"] = "black_humor";
    StoryTone["Satirical"] = "satirical";
    StoryTone["Funny"] = "funny";
    StoryTone["Whimsical"] = "whimsical";
    StoryTone["Heroic"] = "heroic";
    StoryTone["Pulp"] = "pulp";
    StoryTone["Hopeful"] = "hopeful";
    StoryTone["SciFiHard"] = "scifi_hard";
    StoryTone["Cosmic"] = "cosmic";
    StoryTone["Surreal"] = "surreal";
    StoryTone["Melancholic"] = "melancholic";
})(StoryTone || (StoryTone = {}));
export const STORY_TONE_LABELS = {
    [StoryTone.Neutral]: 'Neutral',
    [StoryTone.Intriguing]: 'Intriguing',
    [StoryTone.Dark]: 'Dark',
    [StoryTone.Horror]: 'Horror',
    [StoryTone.Noir]: 'Noir',
    [StoryTone.BlackHumor]: 'Black humor',
    [StoryTone.Satirical]: 'Satirical',
    [StoryTone.Funny]: 'Funny',
    [StoryTone.Whimsical]: 'Whimsical',
    [StoryTone.Heroic]: 'Heroic',
    [StoryTone.Pulp]: 'Pulp adventure',
    [StoryTone.Hopeful]: 'Hopeful',
    [StoryTone.SciFiHard]: 'Hard sci-fi',
    [StoryTone.Cosmic]: 'Cosmic awe',
    [StoryTone.Surreal]: 'Surreal',
    [StoryTone.Melancholic]: 'Melancholic',
};
export function isStoryTone(value) {
    return typeof value === 'string' && Object.values(StoryTone).includes(value);
}
/**
 * Default per-approach trial difficulty, on the GAME scale (success curve needs
 * difficulty > xLow = 40; real levels sit in the hundreds). Used as the editor
 * default and the generator's average-difficulty target.
 */
export const DEFAULT_TRIAL_DIFFICULTY = 200;
// --- Per-user generation quotas --------------------------------------------------
// Each logged-in editor user has a remaining balance per quota bucket; one
// generation consumes one attempt (decremented on success). Records exist only for
// users who have logged into the editor, seeded lazily from the admin-set defaults.
export var GenerationQuota;
(function (GenerationQuota) {
    /** Story + trials text (Claude/OpenAI). */
    GenerationQuota["Text"] = "text";
    /** Cheap draft map background (fal.ai). */
    GenerationQuota["DraftMap"] = "draftMap";
    /** HQ images (final map background now; UX-panel & trial images when added). */
    GenerationQuota["Image"] = "image";
    /** Reading an uploaded map (vision) to ground the story — charged once per image. */
    GenerationQuota["Vision"] = "vision";
})(GenerationQuota || (GenerationQuota = {}));
export const GENERATION_QUOTA_LABELS = {
    [GenerationQuota.Text]: 'Story & trials (text)',
    [GenerationQuota.DraftMap]: 'Draft map',
    [GenerationQuota.Image]: 'HQ images (background, panels, trials)',
    [GenerationQuota.Vision]: 'Map recognition (vision)',
};
/** Starting balance for a newly-tracked user (admin-overridable). */
export const DEFAULT_GENERATION_QUOTAS = {
    [GenerationQuota.Text]: 3,
    [GenerationQuota.DraftMap]: 3,
    [GenerationQuota.Image]: 0,
    [GenerationQuota.Vision]: 3,
};
/** Which quota a generation stage draws from. */
export const STAGE_QUOTA = {
    text: GenerationQuota.Text,
    draft: GenerationQuota.DraftMap,
    final: GenerationQuota.Image,
};
export function isGenerationQuota(value) {
    return typeof value === 'string' && Object.values(GenerationQuota).includes(value);
}
/** Coerce an arbitrary object into a full quotas record (clamped to >= 0 ints). */
export function normalizeQuotas(input) {
    const out = Object.assign({}, DEFAULT_GENERATION_QUOTAS);
    for (const q of Object.values(GenerationQuota)) {
        const v = input === null || input === void 0 ? void 0 : input[q];
        if (typeof v === 'number' && isFinite(v))
            out[q] = Math.max(0, Math.floor(v));
    }
    return out;
}
